import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getExpenseCategoryJSONlistQuery = () => {
  return axios.get(apiurl?.getExpenseCategoryJSONlist);
};

const getExpenseCategoryJSONlist = () => {
  return useQuery(['getExpenseCategoryJSONlist'],
    () => getExpenseCategoryJSONlistQuery(), { refetchOnWindowFocus: false });
};

export default getExpenseCategoryJSONlist;
